// extracted by mini-css-extract-plugin
export default {"navigationDropdowns":"SectionSelection_navigationDropdowns__AtGgu","emptyState":"SectionSelection_emptyState__IdxzE"};